import React, { useRef } from "react";
import { Modal, Button, Form, Input, Select } from "antd";
import { useModalDireccion } from "../../hooks/useModalDireccion";
import { tipoviaOptions, zonaOptions } from "../../utils/dataSelectOptions";

interface IProps {
  modal: boolean;
  CancelarModal: any;
  AceptarModal: any;
  directions: any;
  setDireccion: any;
  namedirections: any;
  setOpenModal?: any;
}

export const ModalDireccion: React.FC<IProps> = (props: IProps) => {
  const formRef = useRef<any>();

  const { direccion, setDireccion, handleChange } = useModalDireccion();

  const fields = [
    { name: "tipo_via", value: direccion.tipo_via },
    { name: "numero_via", value: direccion.numero_via },
    { name: "letra_via", value: direccion.letra_via },
    { name: "zona_via", value: direccion.zona_via },
    { name: "sigo_via", value: direccion.sigo_via },
    { name: "numero2_via", value: direccion.numero2_via },
    { name: "letra2_via", value: direccion.letra2_via },
    { name: "zona2_via", value: direccion.zona2_via },
    { name: "numero3_via", value: direccion.numero3_via },
    { name: "observaciones", value: direccion.observaciones },
    { name: "direccion_completa", value: direccion.direccion_completa },
  ];


  const onCancel = (e) => {
    formRef.current.resetFields();
    setDireccion({
      tipo_via: "",
      numero_via: "",
      letra_via: "",
      zona_via: "",
      sigo_via: "#",
      numero2_via: "",
      letra2_via: "",
      zona2_via: "",
      numero3_via: "",
      observaciones: "",
      direccion_completa: ""
    })
    handleChange(e, 'cancelar', props.directions, props.setDireccion, props.namedirections);
    props.CancelarModal()
  }

  const onSubmit = () => {
    formRef.current.resetFields();
    setDireccion({
      ...direccion,
      tipo_via: "",
      numero_via: "",
      letra_via: "",
      zona_via: "",
      sigo_via: "#",
      numero2_via: "",
      letra2_via: "",
      zona2_via: "",
      numero3_via: "",
      observaciones: "",
      direccion_completa: ""
    })
    props.CancelarModal()
  }

  return (
    <Modal
      title="Ingrese la dirección"
      width={1000}
      style={{ top: 60 }}
      visible={props.modal}
      onCancel={onCancel}
      footer={[
        <Button key="b_cancelar_direccion1" className="button-gray-ghost" onClick={onCancel}>
          Cancelar
        </Button>,
        <Button key="b_aceptar_direccion2" className="button-azul-radius" onClick={() => { formRef.current.submit() }}>
          Aceptar
        </Button>,
      ]}
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144, 0.81)",
      }}
    >
      <Form
        ref={formRef}
        layout="vertical"
        size="large"
        name="modaldireccion"
        fields={fields}
        onFinish={onSubmit}
        onFieldsChange={(_: any, fields: any) => {
          let infoupdate: any = { ...direccion };
          infoupdate[_[0].name[0]] = _[0].value;
          setDireccion(infoupdate);
        }}
      >
        <div className="row">
          <div className="col-6 col-md-3">
            <Form.Item label="Tipo de vía" name="tipo_via"
              rules={[
                {
                  required: true,
                  message: "Campo obligatorio",
                },
              ]}
            >
              <Select
                style={{ width: "100%" }}
                placeholder="Seleccionar.."
                onChange={(e) =>
                  handleChange(e, "tipo_via", props.directions, props.setDireccion, props.namedirections)
                }
              >
                {tipoviaOptions.map(({ value, text }) => (
                  <Select.Option key={value} value={value}>
                    {text}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-6 col-md-3">
            <Form.Item label="Número" name="numero_via"
              rules={[
                {
                  required: true,
                  message: "Campo obligatorio",
                },
              ]}
            >
              <Input
                maxLength={3}
                onChange={(e) =>
                  handleChange(e, "numero_via", props.directions, props.setDireccion, props.namedirections)
                }
              />
            </Form.Item>
          </div>
          <div className="col- col-md-3">
            <Form.Item
              label={
                <span className="font-family-Montserrat-Bold font-size-12px font-color-707070">
                  Letra{" "}
                  <span className="font-family-Montserrat-Regular font-size-10px font-color-707070"> - Opcional</span>
                </span>
              }
              name="letra_via"
            >
              <Input
                onChange={(e) =>
                  handleChange(e, "letra_via", props.directions, props.setDireccion, props.namedirections)
                }
              />
            </Form.Item>
          </div>
          <div className="col-6 col-md-2">
            <Form.Item
              label={
                <span className="font-family-Montserrat-Bold font-size-12px font-color-707070">
                  Zona{" "}
                  <span className="font-family-Montserrat-Regular font-size-10px font-color-707070"> - Opcional</span>
                </span>
              }
              name="zona_via">
              <Select
                style={{ width: "100%" }}
                placeholder="Seleccionar..."
                onChange={(e) =>
                  handleChange(e, "zona_via", props.directions, props.setDireccion, props.namedirections)
                }
              >
                {zonaOptions.map(({ value, text }) => (
                  <Select.Option key={value} value={value}>
                    {text}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-6 col-md-1">
            <Form.Item label=" " name="sigo_via">
              <Input
                // disabled
                readOnly
                value="#"
              />
            </Form.Item>
          </div>
          <div className="col-6 col-md-3">
            <Form.Item label="Número" name="numero2_via"
              rules={[
                {
                  required: true,
                  message: "Campo obligatorio",
                },
              ]}
            >
              <Input
                maxLength={3}
                onChange={(e) =>
                  handleChange(e, "numero2_via", props.directions, props.setDireccion, props.namedirections)
                }
              />
            </Form.Item>
          </div>
          <div className="col-6 col-md-3">
            <Form.Item
              label={
                <span className="font-family-Montserrat-Bold font-size-12px font-color-707070">
                  Letra{" "}
                  <span className="font-family-Montserrat-Regular font-size-10px font-color-707070"> - Opcional</span>
                </span>
              }
              name="letra2_via"
            >
              <Input
                onChange={(e) =>
                  handleChange(e, "letra2_via", props.directions, props.setDireccion, props.namedirections)
                }
              />
            </Form.Item>
          </div>
          <div className="col-6 col-md-3">
            <Form.Item
              label={
                <span className="font-family-Montserrat-Bold font-size-12px font-color-707070">
                  Zona{" "}
                  <span className="font-family-Montserrat-Regular font-size-10px font-color-707070"> - Opcional</span>
                </span>
              }
              name="zona2_via"
            >
              <Select
                style={{ width: "100%" }}
                placeholder="Seleccionar.."
                onChange={(e) =>
                  handleChange(e, "zona2_via", props.directions, props.setDireccion, props.namedirections)
                }
              >
                {zonaOptions.map(({ value, text }) => (
                  <Select.Option key={value} value={value}>
                    {text}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-6 col-md-3">
            <Form.Item label="Número" name="numero3_via"
              rules={[
                {
                  required: true,
                  message: "Campo obligatorio",
                },
              ]}
            >
              <Input
                maxLength={3}
                onChange={(e) =>
                  handleChange(e, "numero3_via", props.directions, props.setDireccion, props.namedirections)
                }
              />
            </Form.Item>
          </div>
          <div className="col-12">
            <Form.Item
              label={
                <span className="font-family-Montserrat-Bold font-size-12px font-color-707070">
                  Observaciones{" "}
                  <span className="font-family-Montserrat-Regular font-size-10px font-color-707070"> - Opcional</span>
                </span>
              }
              name="observaciones"
            >
              <Input
                onChange={(e) =>
                  handleChange(e, "observaciones", props.directions, props.setDireccion, props.namedirections)
                }
              />
            </Form.Item>
          </div>
          <div className="col-12">
            <Form.Item label="Dirección ingresada" name="direccion_completa">
              <Input /*disabled*/ readOnly />
            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
